export const KEY_CODES = {
  ARROW_DOWN_KEY: "ArrowDown",
  ARROW_UP_KEY: "ArrowUp",
  CONTROL_KEY: "Control",
  EDIT_KEY: "F2",
  ENTER: "Enter",
  ESCAPE: "Escape",
  TAB: "Tab"
};
